import "../../../../content/projects/represocial/represocial.css";
import * as React from 'react';
export default {
  React
};